import { get } from 'lodash';

const percentile = (values: number[], p: number) => {
  const sorted = [...values].sort((a, b) => a - b);
  const index = Math.ceil((p / 100) * sorted.length) - 1;
  return sorted[Math.max(0, index)];
};

export const calcMinSize = (path: string, data: object[], columnHeader: string, hasDelta: boolean = false) => {
  const isDelta = path.includes(':delta');
  const multiply = isDelta ? 4 : hasDelta ? 5 : 6;
  const _add = isDelta ? 40 : hasDelta ? 64 : 104;

  const contentLengths = data.map((d) => String(get(d, path)).length);
  const contentLength = percentile(contentLengths, 90);

  return Math.max(contentLength, columnHeader.length) * multiply + _add;
};

export const calcMaxSize = (path: string, data: object[], columnHeader: string, hasDelta: boolean = false) => {
  if (hasDelta) return 100;

  const isDelta = path.includes(':delta');
  const multiply = isDelta ? 4 : 6;
  const _add = isDelta ? 40 : 104;

  const maxContentLength = Math.max(...data.map((d) => String(get(d, path)).length), columnHeader.length);

  return maxContentLength * multiply + _add;
};
